import { render, staticRenderFns } from "./additional-income-information.vue?vue&type=template&id=1954b11c&scoped=true"
import script from "./additional-income-information.vue?vue&type=script&lang=ts"
export * from "./additional-income-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954b11c",
  null
  
)

export default component.exports